<template>
  <form class="email-edit-form" @submit.prevent="submit">
    <div class="email-edit-form__title">
      Изменение Email
    </div>

    <div class="email-edit-form__wrap">
      <ui-input
        v-model="email"
        clearable
        validate="email"
        class="email-edit-form__input"
        label="Новый Email*"
        placeholder="Введите Email"
        :error="mailError"
        @is-valid="onIsValid"
      />

      <!-- <ui-checkbox  пока не нужен
        ref="subscribe-checkbox"
        v-if="isMailValid"
        v-model="subscribe"
        label="Получать сообщения об акциях, скидках и новостях"
      /> -->

      <ui-button
        ref="submit"
        wide
        type="submit"
        :loading="isLoading"
        :disabled="!isMailValid"
        class="email-edit-form__submit"
        text="Изменить"
      />
    </div>
  </form>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'email-edit-form',

    data() {
      return {
        email: '',
        emailResponseError: '',
        // subscribe: true,
        disabledButton: false,
        isLoading: false,
        isInputValid: false,
      };
    },

    computed: {
      ...mapGetters({
        ACCOUNT: 'user/account',
      }),

      mailError() {
        if (this.ACCOUNT.email === this.email)
          return 'Введённый Email совпадает с текущим'
        if (this.emailResponseError)
          return this.emailResponseError;

        return '';
      },

      isMailValid() {
        return !this.mailError && this.isInputValid;
      }
    },

    methods: {
      ...mapActions({
        changeEmail: 'user/changeEmail',
      }),

      onIsValid(isValid) {
        this.isInputValid = isValid;
        this.emailResponseError = ''; // неявно сбрасываем
      },

      async submit() {
        if (!this.isMailValid) return;

        try {
          this.emailResponseError = '';
          this.isLoading = true;
          await this.changeEmail(this.email);
          this.$emit('email-confirmation');
        } catch (e) {
          if (e) {
            this.emailResponseError = e;
          }
        } finally {
          this.isLoading = false;
        }
      }
    }
  }
</script>

<style lang="scss">
.email-edit-form {
  &__title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 48px;
  }

  &__input {
    margin-top: 12px;
  }

  &__submit {
    margin-top: 12px;
  }
}

@include breakpoint("tablet") {
  .account-profile .email-edit-form .ui-checkbox {
    min-height: auto;
    margin-bottom: 24px;
  }

  .email-edit-form{
    width: 392px;
  }
}
</style>
